var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fox-page',{class:_vm.$style.root,attrs:{"disabled":_vm.disabled,"readonly":_vm.readonly}},[_vm._t("default"),((!_vm.$slots.default) && _vm.$env.VUE_APP_DESIGNER && !!_vm.$attrs['vusion-node-path'])?_c('s-empty'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }